import React from 'react';
import { string, func, object } from 'prop-types';
import iconLock from '../../../../../assets/icon-lock.svg';
import {
  ActionButtonsContainer, ActionButton, ArrowDown, ArrowContainer, LockedOverlay, LockText, LockIconContainer,
} from './action-buttons.style';
import lockShape from '../../../../../shapes/lock';
import { formatUsername } from '../../../../../utils/common';
import ImageIcon from '../../image-icon';

/**
 * The action buttons component
 * @param {object} params - Object containing component props
 * @param {func} params.onActionChanged - Handles when an action is changed
 * @param {object} params.selectedAction - Current selected action
 * @param {object} params.actions - Actions definition
 * @param {object} params.lock - Load lock
 * @return {element} - The action buttons element
 */
const ActionButtons = ({
  onActionChanged,
  selectedAction,
  actions,
  lock,
}) => {
  /**
   * Renders a lock overlay over this component
   * @return {element} - Lock Overlay
   */
  const renderLockOverlay = () => (
    <LockedOverlay>
      <LockIconContainer>
        <ImageIcon src={iconLock} height={20} width={20} altString="lock" />
      </LockIconContainer>
      <LockText>
        You cannot perform a key tracking action because the load is
        <br />
        {`locked by ${formatUsername(lock.initiatorName)}.`}
      </LockText>
    </LockedOverlay>
  );

  const actionKeys = Object.keys(actions);
  return (
    <div data-testid="action-buttons-test-id">
      {lock?.loadId && !lock?.ownedByUser && renderLockOverlay()}
      <ActionButtonsContainer>
        {
          actionKeys.map((key) => (
            <ActionButton
              fieldId={actions[key]}
              isActive={actions[key] === selectedAction}
              size="small"
              text={actions[key]}
              onClick={() => onActionChanged(key)}
              key={key}
            />
          ))
        }
      </ActionButtonsContainer>
      {selectedAction
        && (
          <ArrowContainer>
            <ArrowDown />
          </ArrowContainer>
        )}
    </div>
  );
};

ActionButtons.propTypes = {
  selectedAction: string,
  // Alowing this disable since enum can update over time
  // eslint-disable-next-line react/forbid-prop-types
  actions: object.isRequired,
  onActionChanged: func,
  lock: lockShape,
};

ActionButtons.defaultProps = {
  onActionChanged: () => { },
  selectedAction: null,
  lock: null,
};

export default ActionButtons;
